import { APIResponse } from '@src/types/common/api'
import { CreateTransaction, TopUpPackage, TransactionData } from '@src/types/top-up'
import { request } from './request'

export async function createTransaction(
  data: CreateTransaction,
): Promise<APIResponse<TransactionData>> {
  return request.post('/twitter/create-transaction', data)
}

export async function sendTransaction(data: CreateTransaction): Promise<APIResponse<string>> {
  return request.post('/twitter/send-transaction', data)
}

export async function getTopUpPackages(): Promise<APIResponse<TopUpPackage[]>> {
  return request.get('/twitter/packages')
}

export async function getUserCredits(): Promise<APIResponse<number>> {
  return request.get('/twitter/credits')
}
export async function CheckPaymentTransaction(
  orderNo: string,
): Promise<APIResponse<{ transaction: boolean }>> {
  return request.get('/payments/check-transaction', { params: { orderNo } })
}

export async function createPaymentTransaction(
  pgId: number,
): Promise<APIResponse<{ transaction: { orderNo: string; address: string } }>> {
  return request.post('payments/create-transaction', { pgId })
}
